import { Injectable } from '@angular/core';
import { FileTableEntry } from '@r1-compass-library/components/file-table/file-table.model';

@Injectable({
    providedIn: 'root',
})
export class AssetListSortingService {
    /**
     * Sort by item type (folder or asset), then by id.
     */
    public defaultSort(items: FileTableEntry[]): FileTableEntry[] {
        return [...items].sort((a, b) => {
            if (a.itemType !== b.itemType) {
                return a.itemType === 'folder' ? -1 : 1; // Folders come first
            }

            return a.id - b.id; // Sort by ID ascending
        });
    }

    public defaultSortWithEnabled(items: FileTableEntry[]): FileTableEntry[] {
        return [...items].sort((a, b) => {
            if (a.itemType !== b.itemType) {
                return a.itemType === 'folder' ? -1 : 1; // Folders come first
            }

            if ('enabled' in a && 'enabled' in b && a.enabled !== b.enabled) {
                if (a.enabled === undefined) return -1;
                if (b.enabled === undefined) return 1;
                return Number(b.enabled) - Number(a.enabled); // enabled items first
            }

            return a.id - b.id; // Sort by ID ascending
        });
    }
}
